import React, { FunctionComponent, useEffect } from 'react'
import { Form, Input, Select, Button, App } from 'antd'
import { VehicleType, Agencies, DeviceType } from 'server'
import { useFeathersClient } from '@strac/react-client-feathers'
import { useQuery } from '@tanstack/react-query'
import { getAllData } from '../../utils/data'

interface IProps {
  vehicleId: number
  handleClose?: () => void
}

const EditVehicleForm: FunctionComponent<any> = (props: IProps) => {
  const { vehicleId, handleClose } = props

  const client = useFeathersClient()

  const { notification } = App.useApp()

  const { data: vehicle /*, isLoading: vehicleLoading*/ } = useQuery({
    queryKey: ['vehicle', 'get', vehicleId],
    queryFn: () => client.service('vehicle').get(vehicleId)
  })

  const vehicleTypesQuery = {}
  const { data: vehicleTypes, isLoading: vehicleTypesLoading } = useQuery({
    queryKey: ['vehicle-type', 'find', vehicleTypesQuery],
    queryFn: () => getAllData(client, 'vehicle-type', vehicleTypesQuery),
    placeholderData: []
  })

  const deviceTypesQuery = {}
  const { data: deviceTypes, isLoading: deviceTypesLoading } = useQuery({
    queryKey: ['device-type', 'find', deviceTypesQuery],
    queryFn: () => getAllData(client, 'device-type', deviceTypesQuery),
    placeholderData: []
  })

  const agenciesQuery = {
    mod_assettrak: true
  }
  const { data: agencies, isLoading: agenciesLoading } = useQuery({
    queryKey: ['agencies', 'find', agenciesQuery],
    queryFn: () => getAllData(client, 'agencies', agenciesQuery),
    placeholderData: []
  })

  const [form] = Form.useForm()

  useEffect(() => {
    if (!vehicle) return
    form.setFieldsValue({
      name: vehicle?.name,
      vehicle_type_id: vehicle?.vehicle_type_id,
      agency_id: vehicle?.agency_id,
      device_type_id: vehicle.device_type_id
    })
  }, [vehicle, form])

  const renderVehicleType = (vehicleType: VehicleType) => {
    return (
      <Select.Option key={vehicleType.id} value={vehicleType.id}>
        {vehicleType?.name}
      </Select.Option>
    )
  }

  const renderDeviceType = (deviceType: DeviceType) => {
    return <Select.Option key={deviceType.id} value={deviceType.id}>
      {deviceType?.name}
    </Select.Option>
  }

  const renderAgency = (agency: Agencies) => {
    return (
      <Select.Option key={agency.id} value={agency.id}>
        {agency?.friendly_name || agency?.name}
      </Select.Option>
    )
  }

  const handleSave = () => {
    const values = form.getFieldsValue()
    console.log('Save vehicle', values)
    client
      .service('vehicle')
      .patch(vehicleId, {
        name: values.name,
        vehicle_type_id: values.vehicle_type_id,
        agency_id: values.agency_id,
        device_type_id: values.device_type_id
      })
      .then((response: any) => {
        console.log('Vehicle updated', response)
        notification.success({
          message: 'Vehicle Updated',
          description: 'Vehicle has been updated successfully'
        })
        handleClose?.()
      })
      .catch((error: any) => {
        console.error('Vehicle update failed', error)
        notification.error({
          message: 'Vehicle Update Failed',
          description: 'Vehicle failed to update'
        })
      })
  }

  return (
    <Form
      initialValues={{
        name: vehicle?.name,
        vehicle_type_id: vehicle?.vehicle_type_id,
        agency_id: vehicle?.agency_id
      }}
      form={form}
      layout={'vertical'}
    >
      <Form.Item name={'name'} label={'Unit Name'}>
        <Input allowClear={true} />
      </Form.Item>
      <Form.Item name={'vehicle_type_id'} label={'Vehicle Type'}>
        <Select loading={vehicleTypesLoading}>{vehicleTypes.map(renderVehicleType)}</Select>
      </Form.Item>
      <Form.Item name={'device_type_id'} label={'Device Type'}>
        <Select loading={deviceTypesLoading}>{deviceTypes.map(renderDeviceType)}</Select>
      </Form.Item>
      <Form.Item name={'agency_id'} label={'Agency'}>
        <Select loading={agenciesLoading}>{agencies.map(renderAgency)}</Select>
      </Form.Item>
      <Form.Item>
        <Button style={{ float: 'right' }} type={'primary'} onClick={handleSave}>
          Save
        </Button>
      </Form.Item>
    </Form>
  )
}

export default EditVehicleForm
